export default __webpack_public_path__ + "static/media/smart-farm.321dcd3a.png";